module.exports = __webpack_public_path__ + "img/head.6622baa1.png";